import { render } from "./Aufmacher.vue?vue&type=template&id=49c2bf7a"
import script from "./Aufmacher.vue?vue&type=script&lang=js"
export * from "./Aufmacher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__